import React from 'react';
import { ModalStackItem } from './redux/types';
import DaModal, { Props as DaModalProps } from './DaModal';

export interface Props extends Omit<DaModalProps, 'modal'> {
  modals?: ModalStackItem[];
}

const Modals: React.FC<Props> = ({ modals = [], ...rest }) => {
  if (modals.length === 0) {
    return null;
  }

  const renderedModals = modals?.map((modal, index) => (
    <DaModal modal={modal} {...rest} key={index} />
  ));

  return renderedModals ? (
    // Typescript doesn't like us returning arrays for a React.FC return type despite it being totally fine.
    // Context here: https://github.com/DefinitelyTyped/DefinitelyTyped/issues/18912
    <>
      {renderedModals?.map((modal, index) => (
        <React.Fragment key={index}>{modal}</React.Fragment>
      ))}
    </>
  ) : null;
};
Modals.displayName = 'Modals';

export default Modals;
